import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client.js";

/**
 * FIX-012 closure correction (2026-09-07, canonical copy directive):
 * the confirmation shown after submitting is the SAME regardless of
 * whether THIS specific email matches a real account — the
 * non-enumeration contract holds all the way through to the UI (see
 * `/auth/forgot-password`'s own doc comment). Exactly one fixed string
 * is shown, always, per an explicit user directive naming this precise
 * text and prohibiting any explanatory/conditional addition (no "if an
 * account exists", no provider/configuration detail) — never rewrite,
 * paraphrase, or extend it.
 */
export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", null, { email });
    } finally {
      setSubmitting(false);
      setSent(true);
    }
  }

  return (
    <div className="login-shell">
      <div className="card login-card">
        <h2>Forgot your password?</h2>
        {sent ? (
          <div className="success-banner">check your inbox for a password reset link</div>
        ) : (
          <form onSubmit={(event) => void handleSubmit(event)}>
            <p className="muted">Enter your account email and we'll send you a reset link.</p>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" required autoComplete="username" value={email} onChange={(event) => setEmail(event.target.value)} />
            </div>
            <button type="submit" className="primary" disabled={submitting} style={{ width: "100%" }}>
              {submitting ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <div className="auth-links">
          <Link to="/login">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
